export type ServiceModel = {
  assigned_agency_provider_ids?: number[],
  assigned_provider_ids?: number[],
  cache_key: number,
  id: number,
  options?: any,
  short_name: string,
  title: string,
}

const state = {
  assigned_provider_ids: [],
  id: null,
  options: {},
  short_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'short_name' },
  { key: 'title' },
]

export default state
